/**
 *
 * @author Matthew Rawson @ 21/11/2018 14:22
 * @description
 * @notes
 */
import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {Row, Col} from "react-bootstrap"
import styled from "styled-components"
import moment from "moment-timezone"
import {get, isEmpty} from "lodash"

import getId from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"
import authentication from "@irati/auth"
import Button from "@irati/ui/src/Button"
import padding from "@irati/ui/src/global/padding"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {Para} from "@irati/ui/src/Labels"
import {ReportsContext} from "@irati/insights/context"

import CreateReportMutation from "@irati/insights/apollo/mutation/report/create"
import clearPagesFromCache from "@irati/insights/apollo/helpers/clearPagesFromCache"
import {
  query as reportsQuery,
  defaultParams as defaultReportsQueryParams
} from "@irati/insights/apollo/query/report/list"
import {hangPromise} from "@irati/utils/promise"
import {overrideAuth} from "@irati/insights/utils/apollo"

const REPORT_TYPE = "insights-cycle"
const EXPORT_TYPE = "pdf"

const ButtonWrapper = styled(Col)`
  display: flex;
  justify-content: flex-end;
  padding-left: ${padding.base};
  padding-right: ${padding.base};
  margin-top: ${padding.small};
  ${minWidthMedia.desktop`
    margin-top: 0
  `}
`

class CreateReportFooter extends PureComponent {
  static propTypes = {
    filters: PropTypes.object,
    isDisabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    onCompleted: PropTypes.func,
    schedule: PropTypes.object,
    minResponseCount: PropTypes.bool,
    onBeforeCreate: PropTypes.func
  }
  static defaultProps = {
    filters: {},
    isDisabled: false,
    isLoading: false,
    onCompleted: () => {
    },
    minResponseCount: true,
    schedule: {},
    onBeforeCreate: () => {
    }
  }

  getMutationParams = ({tenantId: tenantUuid}) => {
    const {filters} = this.props
    const {
      teamId: teamUuid,
      driverId,
      time: timeValue
    } = filters
    const {schedule: {id: cycleId, firstSurvey}} = this.props
    const to = moment().utc().format()
    const from = timeValue || get(firstSurvey, "createdAt")
    const displayTimezone = moment.tz.guess()
    return {
      tenantUuid,
      cycleId,
      teamUuid,
      driverId,
      from,
      to,
      displayTimezone,
      reportType: REPORT_TYPE,
      exportType: EXPORT_TYPE
    }
  }

  handleCreate = (createReport, {tenantId: tenantUuid, isDemo, demoTenantAccessToken}) => {
    const {onBeforeCreate} = this.props
    onBeforeCreate()
    createReport({
      refetchQueries: [{
        query: reportsQuery,
        variables: {
          params: {
            ...defaultReportsQueryParams,
            tenantUuid,
            userUuid: isDemo ? "demo" : authentication.user().uuid, // @todo remove hardcoded userUuid (after BE fix)
            offset: 0
          }
        },
        ...overrideAuth(demoTenantAccessToken, isDemo)
      }]
    })
  }


  render() {
    const idNamespace = getId("Footer", this.props)
    const {isDisabled, onCompleted, minResponseCount, schedule, isLoading} = this.props
    return (
      <ReportsContext.Consumer>
        {(reportsContext) => {
          const {tenantId, isDemo, demoTenantAccessToken} = reportsContext

          return (
            <CreateReportMutation
              variables={{params: this.getMutationParams({tenantId})}}
              onCompleted={(obj) => onCompleted(obj, isDemo)}
              update={(cache) => clearPagesFromCache("reports", cache)}
              {...overrideAuth(demoTenantAccessToken, isDemo)}>
              {(createReport, {loading: mutationLoading}) => {
                const loading = isLoading || mutationLoading ? hangPromise() : false
                const shouldShowError = !loading && !minResponseCount && !isEmpty(schedule)
                return (
                  <Row id={idNamespace}>
                    <Col md={8} xs={12}>
                      {shouldShowError &&
                      <Para><FormattedMessage id="insights.reports.create.minResponseValidationError" /></Para>}
                    </Col>
                    <ButtonWrapper md={4} xs={12}>
                      <Button
                        disabled={!!(isDisabled || loading)}
                        load={loading}
                        primary
                        onClick={() => this.handleCreate(createReport, reportsContext)}>
                        <FormattedMessage id="insights.reports.create.cta" />
                      </Button>
                    </ButtonWrapper>
                  </Row>
                )
              }}
            </CreateReportMutation>
          )
        }}
      </ReportsContext.Consumer>
    )
  }
}

export default CreateReportFooter
